// ============================================================================
// RANGE TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'range-tree',
  name: 'Range Tree',
  category: 'Graphs',
  complexity: {
    time: 'O(log² N + k)',
    space: 'O(N log N)'
  },
  description: 'A data structure for efficient orthogonal range queries in multi-dimensional space. It organizes points in a balanced BST where each node stores a secondary data structure for queries in lower dimensions.'
};
